"use client";

import Script from "next/script";
import React from "react";
import { useUser } from "~/modules/user/hooks/useUser";
import { env } from "~/env.mjs";

// // // //

// Pull Intercom App ID from env
// NOTE - the `NEXT_PUBLIC_` prefix must be included or else this env variable won't load in the app
const INTERCOM_APP_ID = env.NEXT_PUBLIC_INTERCOM_APP_ID;

/**
 * IntercomScript
 * Loads Intercom in the app
 */
export function IntercomScript() {
    const { user, loading } = useUser();

    if (!INTERCOM_APP_ID) {
        return null;
    }

    if (loading) {
        return null;
    }

    // If the user is authenticated -> include user_id + user_hash to intercom settings
    let intercom_hmac = "";
    if (user.intercom_hmac !== null) {
        intercom_hmac = `, user_id: "${user.email}", user_hash: "${user.intercom_hmac}"`;
    }

    // NOTE - the intercom-settings script includes a check to hide the Intercom launcher on mobile devices
    // Doc: https://www.intercom.com/help/en/articles/189-disable-or-hide-the-messenger
    return (
        <React.Fragment>
            <Script
                id="intercom-settings"
                // strategy="beforeInteractive"
            >
                {`
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  const isMobile = mobileRegex.test(navigator.userAgent);
  
  window.intercomSettings = {
    api_base: "https://api-iam.intercom.io",
    app_id: "${INTERCOM_APP_ID}",
    hide_default_launcher: isMobile${intercom_hmac}
  };
  `}
            </Script>
            <Script id="intercom-init" strategy="afterInteractive">
                {`
(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/${INTERCOM_APP_ID}';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
  `}
            </Script>
        </React.Fragment>
    );
}
